module.exports = __webpack_public_path__ + "img/success-3d.94ec90bb.png";